<template>
    <span 
        class="cursor-pointer text-theme" 
        :class="className"
        @click="getPreviousDate"
    >
        <SquareArrowLeft
            :size="size"
            :stroke-width="strokeWidth"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :data-bs-title="title"
        />
    </span>
</template>

<script>
import {appMixin} from '../../mixin/appMixin';
import {
    SquareArrowLeft
} from 'lucide-vue-next';

export default {
    name: 'PreviousDateIcon',
    mixins: [appMixin],
    components: {
        SquareArrowLeft
    },
    props: {
        modelValue: {
            default: new Date(),
        },
        className: {
            type: String,
            default: ''
        },
        decrement: {
            type: String,
            default: 'day' // day, month, or year
        },
        size: {
            type: Number,
            default: 24
        },
        strokeWidth: {
            type: Number,
            default: 2
        },
        title: {
            type: String,
            default: 'Previous Date'
        }
    },
    methods: {
        getPreviousDate() {
            let previousDate = this.momentObj(this.modelValue);
            // decrement by type
            if(this.decrement === 'day') {
                previousDate.subtract(1, 'day');
            } else if(this.decrement === 'month') {
                previousDate.subtract(1, 'month');
            } else if(this.decrement === 'year') {
                previousDate.subtract(1, 'year');
            }
            this.$emit('update:modelValue', previousDate);
        }
    }
}
</script>